<div class="bottom-navigation-controls layout-row">
    <div class="navigation-links" layoutRow>
        <ng-container *ngFor="let item of navigationService.navigations">
            <div *ngIf="item.name && item.isVisible() && !item.isHiddenOnBottomSection">
                <button 
                    mat-icon-button 
                    class="nav-button" 
                    [routerLink]="item.url" 
                    routerLinkActive="current-location">
                        <mat-icon>{{item.icon}}</mat-icon>
                        {{item.name}}
                </button>
            </div>
        </ng-container>
    </div>
</div>